import SignUpForm from "./Register/SignUpForm";

const RegisterPage = () => {
  return (
  <div className="flex items-center justify-center sm:h-screen w-screen bg-gradient-to-r from-blue2 via-blue1 to-blue3">
  <SignUpForm />
</div>

  );
};

export default RegisterPage;
